import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store'

export interface UserState {
  isOpen: boolean;
  userInfo: any;
  earlywarningShow:boolean
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements UserState {
  public isOpen = false;
  public userInfo: any = null;
  public earlywarningShow = true
  public psdEasy = false
  public mallInfo:any = {}

  @Mutation
  private SET_USER_INFO(user_info: any) {
    this.userInfo = user_info;
  }
  @Mutation
  private SET_earlywarningShow(type: any) {
    this.earlywarningShow = type;
  }
  @Mutation
  private SET_psdEasy(type: any) {
    this.psdEasy = type;
  }
  @Mutation
  private SET_mallInfo(type: any) {
    this.mallInfo = type;
  }

  @Action
  public setUserInfo(user_info: any) {
    this.SET_USER_INFO(user_info);
  }
  @Action
  public setEarlywarningShow(type: any) {
    // console.log(type,88)
    this.SET_earlywarningShow(type);
  }
  @Action
  public setPsdEasy(type: any) {
    // console.log(type,88)
    this.SET_psdEasy(type);
  }
  @Action
  public setmallInfo(type: any) {
    // console.log(type)
    this.SET_mallInfo(type);
  }
}

export const UserModule = getModule(User);